import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import APIs from "../../APIs";
import { Modal } from "bootstrap";
import { GoogleMap, Marker, useLoadScript, Polyline } from "@react-google-maps/api";
import { clearPickupDropoff } from "../../redux/addressSlice";
import { clearShipment } from "../../redux/shipmentSlice";
import { toast } from "react-toastify";
import "../../index.css"; // <-- your override should be here
import { GOOGLE_MAP_KEY } from "../../Utils/Utils";

const mapContainerStyle = {
    width: "100%",
    height: "400px",
    borderRadius: "15px",
};

const Step5 = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const pickupAddress = useSelector((state) => state.address.pickupAddress);
    const dropoffAddress = useSelector((state) => state.address.dropoffAddress);
    const { shipmentId: paramShipmentId } = useParams();
    const [termsChecked, setTermsChecked] = useState(false);
    const [showError, setShowError] = useState(false); // new state for button loading
    const [testRequest, setTestRequest] = useState(false)
    const [CCImport, setCCImport] = useState(false)
    const [CCExport, setCCExport] = useState(false)
    const [selectedFlight, setSelectedFlight] = useState(null)

    const {
        // categoryId, // unused but kept in state if required later
        items = [],
        pickupDate,
        pickupTime,
        customTime,
        urgencyLevel,
    } = useSelector((state) => state.shipment || {});

    const [errors, setErrors] = useState({});
    const [flightDetails, setFlightDetails] = useState(null);
    const [flightDetails2, setFlightDetails2] = useState(null);
    const [otherCharge, setOtherCharge] = useState(null);

    const [loading, setLoading] = useState(true);
    const [loading2, setLoading2] = useState(false);
    const [selectedFlightId, setSelectedFlightId] = useState(null);
    const [submitting, setSubmitting] = useState(false); // new state for button loading
    const [totalWeight, setTotalWeight] = useState(0);
    const { isLoaded } = useLoadScript({
        // replace with env var / safer approach for real apps
        googleMapsApiKey: GOOGLE_MAP_KEY,
    });
    const shipmentsId = sessionStorage.getItem("shipment_id");

    const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
    const userId = userData?.user_id;
    const [user, setUser] = useState({});
    const [categoryName, setCategoryName] = useState("");
    const [categoryDescription, setCategoryDescription] = useState("");
    const [showStops, setShowStops] = useState(false);

    useEffect(() => {
        const total = items.reduce((sum, it) => {
            const itemTotal = (Number(it.quantity) || 0) * (Number(it.itemWeight) || 0);
            return sum + itemTotal;
        }, 0);
        console.log("totalWeight", total)
        if (flightDetails?.currency_code) {
            getFlightDetails2(total, flightDetails?.currency_code)
        }
        setTotalWeight(total);
    }, [items, flightDetails]);
    console.log("items", items)

    const formatDropoffAddress = (dropoff) => {
        if (!dropoff) return "";

        return `${dropoff.address}`;
    };

    const getFlightDetails2 = async (weight, currency_code) => {
        setLoading2(true);
        // Your params
        const params = {
            pickup_address: formatDropoffAddress(pickupAddress),
            drop_address: formatDropoffAddress(dropoffAddress),
            pickup_date: pickupDate,
            total_weight: weight,
            currency: currency_code,
            pickup_time: pickupTime
        };

        // ✅ Log all parameters before API call
        console.log("📦 API Params for getFlightDetails2:", params);
        try {
            const response = await APIs.post(
                "flightradar/getFlightDetails",
                params,
                { headers: { "Content-Type": "application/json" } }
            );

            if (response?.data?.status === "success") {
                setLoading2(false);
                setFlightDetails2(response.data.data.flight_payload.top_flight_options || null);
                setSelectedFlight(response.data.data.flight_payload.top_flight_options[0] || null);
                console.log("getFlightDetails2", response.data.data.flight_payload.top_flight_options)
            } else {
                setLoading2(false);
                setFlightDetails2(null);
                console.warn("Failed to fetch flight getFlightDetails2:", response?.data?.message);
            }
        } catch (error) {
            setLoading2(false);
            console.error("Error fetching flight getFlightDetails2:", error);
            setFlightDetails2(null);
        } finally {
            setLoading2(false);
        }
    };
    useEffect(() => {
        // Retrieve saved values from sessionStorage
        const savedCategoryName = sessionStorage.getItem("categoryName");
        const savedCategoryDescription = sessionStorage.getItem("categoryDescription");

        if (savedCategoryName) setCategoryName(savedCategoryName);
        if (savedCategoryDescription) setCategoryDescription(savedCategoryDescription);

    }, []);
    // fetch user
    useEffect(() => {
        const fetchUser = async () => {
            if (!userId) return;
            try {
                const res = await APIs.post(
                    "user/getUserById",
                    { user_id: userId },
                    { headers: { "Content-Type": "application/json" } }
                );
                setUser(res.data?.data || {});
            } catch (err) {
                console.error("Error fetching user:", err);
            }
        };
        fetchUser();
    }, [userId]);

    // fetch flight details
    useEffect(() => {
        const getFlightDetails = async () => {
            setLoading(true);
            try {
                const response = await APIs.post(
                    "booking/getFlightDetailsByShipment",
                    { shipment_id: paramShipmentId },
                    { headers: { "Content-Type": "application/json" } }
                );

                if (response?.data?.status === "success") {
                    setFlightDetails(response.data.data || null);
                    setOtherCharge(response.data.data.allCharges.other_charges.other_miscellaneous_charges)
                    console.log("setFlightDetails", response.data.data)
                    // default select first flight if exists
                    const firstFlightId = response.data?.data?.flights?.[0]?.flight_id;
                    setSelectedFlightId(firstFlightId || null);
                } else {
                    setFlightDetails(null);
                    console.warn("Failed to fetch flight details:", response?.data?.message);
                }
            } catch (error) {
                console.error("Error fetching flight details:", error);
                setFlightDetails(null);
            } finally {
                setLoading(false);
            }
        };

        if (paramShipmentId) {
            getFlightDetails();
        } else {
            setLoading(false);
        }
    }, [paramShipmentId]);

    // create or edit quote for currently selected flight
    const handleQuote = async () => {
        // if (!userId) {
        //   toast.warning("Please login before requesting a quote.", { position: "top-right" });
        //   return;
        // }

        // if (!selectedFlightId) {
        //   toast.warning("Please select a flight before requesting a quote.", { position: "top-right" });
        //   return;
        // }
        if (submitting) return; // prevent multiple clicks
        setSubmitting(true);
        const allCharges = flightDetails?.allCharges || {};
        const flightCost = Number(selectedFlight?.flight_cost || 0);
        const roadFrom = Number(selectedFlight?.roadCostFrom || 0);
        const roadTo = Number(selectedFlight?.roadCostTo || 0);
        const otherPay = (
            (Number(flightDetails.allCharges?.other_charges?.custom_clearance_charges || 0) *
                (Number(CCImport) + Number(CCExport))) +
            Number(allCharges?.other_charges?.documentation_charges || 0) +
            Number(allCharges?.other_charges?.other_miscellaneous_charges || 0)

        ).toFixed(2);

        // Total carrier charges
        const totalCarrierCharges = flightCost + roadFrom + roadTo;

        // Total pay amount
        const totalPayAmount =
            Number(totalCarrierCharges || 0) +
            Number(selectedFlight?.percentage_charges_total || 0) +
            Number(otherPay || 0);

        // Payload
        const payload = {
            shipment_id: paramShipmentId,
            flight_id: 1,
            carrier_fees: flightCost,
            road_cost: roadFrom + roadTo,
            flight_cost: flightCost,
            custom_clearance_charges: (
                Number(flightDetails.allCharges?.other_charges?.custom_clearance_charges || 0) *
                (Number(CCImport) + Number(CCExport))
            ),
            documentation_charges: allCharges?.other_charges?.documentation_charges || 0,
            other_charges: allCharges?.other_charges?.other_miscellaneous_charges || 0,
            total_carrier_charges: roadFrom + roadTo + flightCost,
            total_handling_charges: otherPay,
            admin_percentage: Number(selectedFlight?.admin_percentage || 0),
            admin_commission_charges: Number(selectedFlight?.percentage_charges_total || 0),
            total_pay_amount: totalPayAmount,
            select_flight: selectedFlight,
            user_id: userId,
            is_test_request: testRequest ? 'Yes' : 'No',
            is_icc_required: CCImport ? 'Yes' : 'No',
            is_ecc_required: CCExport ? 'Yes' : 'No'
        };

        console.log("Payload:", payload);

         try {
             const existingQuoteId = sessionStorage.getItem("currentQuoteId");
             let response;
             if (existingQuoteId) {
                 const editPayload = { ...payload, quote_id: existingQuoteId };
                 response = await APIs.post("quote/editQuote", editPayload, {
                     headers: { "Content-Type": "application/json" },
                 });
             } else {
                 response = await APIs.post("/quote/addQuote", payload, {
                     headers: { "Content-Type": "application/json" },
                 });
             }
 
             if (response.status === 201 || response?.data?.status === "success") {
                 const createdId = response?.data?.data?.quote_id;
                 if (createdId) {
                     sessionStorage.setItem("currentQuoteId", createdId);
                 }
                 const modalEl = document.getElementById("sucessModalToggle");
                 if (modalEl) {
                     const successModal = new Modal(modalEl);
                     successModal.show();
                 } else {
                     toast.success(existingQuoteId ? "Quote updated successfully." : "Quote created successfully.");
                 }
             } else {
                 toast.error(response?.data?.message || (existingQuoteId ? "Failed to update quote." : "Failed to create quote."));
             }
         } catch (error) {
             console.error("Error creating quote:", error);
             toast.error(error.response?.data?.message || "Something went wrong");
         } finally {
             setSubmitting(false); // re-enable button
         }
    };

    console.log("flightDetails=====", flightDetails?.currency_symbol);
    const handleDashboardClick = () => {
        dispatch(clearPickupDropoff());
        dispatch(clearShipment());
        sessionStorage.removeItem("categoryId");
        sessionStorage.removeItem("shipment_id"); // correct key (you store "shipment_id" elsewhere)
        sessionStorage.removeItem("existingQuoteId");
        sessionStorage.removeItem("currentQuoteId");
        sessionStorage.removeItem("categoryName");
        sessionStorage.removeItem("categoryDescription");
        window.location.href = "/quotation";
        // navigate("/Dashboard"); 
    };

    const formatAddress = (addr) =>
        addr
            ? `${addr.address || ""}${addr.city ? `, ${addr.city}` : ""}${addr.state ? `, ${addr.state}` : ""}${addr.zip_code ? `, ${addr.zip_code}` : ""
            }`
            : "Address not set";

    const pickupLat = pickupAddress?.address_lat ? parseFloat(pickupAddress.address_lat) : null;
    const pickupLng = pickupAddress?.address_long ? parseFloat(pickupAddress.address_long) : null;
    const dropLat = dropoffAddress?.address_lat ? parseFloat(dropoffAddress.address_lat) : null;
    const dropLng = dropoffAddress?.address_long ? parseFloat(dropoffAddress.address_long) : null;

    const centerLat = pickupLat && dropLat ? (pickupLat + dropLat) / 2 : pickupLat || dropLat || 0;
    const centerLng = pickupLng && dropLng ? (pickupLng + dropLng) / 2 : pickupLng || dropLng || 0;

    const path =
        pickupLat && pickupLng && dropLat && dropLng
            ? [
                { lat: pickupLat, lng: pickupLng },
                { lat: dropLat, lng: dropLng },
            ]
            : [];

    const getEstimatedDelivery = (flight) => {
        const date = new Date(pickupDate);
        const estimated = new Date(
            date.getTime() + flight.total_time_hr * 60 * 60 * 1000
        );

        return new Date(estimated.toLocaleString()).toLocaleDateString("en-US", {
            weekday: "short",
            month: "short",
            day: "numeric",
            year: "numeric"
        });
    };

    return (
        <div className="page-wrapper about-us">
            <div className="page-content">
                <section className="step-section-md">
                    <div className="container">
                        <div className="row">
                            {/* Left Column */}
                            <div className="col-lg-6">
                                <div className="shipment-information-new">
                                    {/* STEP HEADER & USER */}
                                    <div className="step-header d-flex align-items-center justify-content-between">
                                        <Link to="/">
                                            <img src="/images/logo1.jpg" alt="Logo" className="img-fluid" />
                                        </Link>
                                        {user && Object.keys(user).length > 0 ? (
                                            <div className="align-items-center d-flex gap-1">
                                                <img
                                                    src={user.profile_image || "/images/user.png"}
                                                    alt="Profile"
                                                    style={{
                                                        width: "32px",
                                                        height: "32px",
                                                        borderRadius: "50%",
                                                        objectFit: "cover",
                                                        marginLeft: "12px",
                                                    }}
                                                />
                                                <span style={{ marginLeft: 10 }}>{user.full_name || ""}</span>
                                            </div>
                                        ) : (
                                            <a data-bs-toggle="modal" href="#LoginModalToggle">
                                                <i className="eagle-base-icon-user" /> Sign In
                                            </a>
                                        )}
                                    </div>

                                    {/* Map */}
                                    <div
                                        className="map-responsive"
                                        style={{ borderRadius: 15, overflow: "hidden", border: "1px solid #c5c1c1", marginTop: 15 }}
                                    >
                                        {isLoaded && pickupLat && pickupLng && dropLat && dropLng ? (
                                            <GoogleMap
                                                mapContainerStyle={mapContainerStyle}
                                                center={{ lat: centerLat, lng: centerLng }}
                                                zoom={15}
                                                onLoad={(map) => {
                                                    const bounds = new window.google.maps.LatLngBounds();
                                                    bounds.extend({ lat: pickupLat, lng: pickupLng });
                                                    bounds.extend({ lat: dropLat, lng: dropLng });
                                                    map.fitBounds(bounds);
                                                }}
                                            >
                                                <Marker
                                                    position={{ lat: pickupLat, lng: pickupLng }}
                                                    // label={{ text: "P", color: "#fff" }}
                                                    icon={{
                                                        url: "/images/srcmap.png", // or full URL
                                                        scaledSize: new window.google.maps.Size(30, 40), // resize image
                                                        anchor: new window.google.maps.Point(20, 40), // bottom center
                                                    }}
                                                />
                                                <Marker
                                                    position={{ lat: dropLat, lng: dropLng }}
                                                    // label={{ text: "D", color: "#fff" }}
                                                    icon={{
                                                        url: "/images/destmap.png", // or full URL
                                                        scaledSize: new window.google.maps.Size(30, 40), // resize image
                                                        anchor: new window.google.maps.Point(20, 40), // bottom center
                                                    }}
                                                />
                                                <Polyline
                                                    path={[{ lat: pickupLat, lng: pickupLng }, { lat: dropLat, lng: dropLng }]}
                                                    options={{
                                                        strokeColor: "#007bff",
                                                        strokeOpacity: 0.8,
                                                        strokeWeight: 3,
                                                        icons: [{ icon: { path: "M 0,-1 0,1", strokeOpacity: 1, scale: 4 }, offset: "0", repeat: "20px" }],
                                                    }}
                                                />
                                            </GoogleMap>
                                        ) : (
                                            <div style={{ padding: 20, textAlign: "center" }}>Loading map...</div>
                                        )}

                                    </div>

                                    {/* Pickup & Dropoff */}
                                    <div className="form-to-location mb-3" style={{ marginTop: 15 }}>
                                        <div className="form-location d-flex align-items-start">
                                            <div className="icon-ftl">
                                                <i className="ti-arrow-up" />
                                            </div>
                                            <div className="flex-1" style={{ marginLeft: 10 }}>
                                                <label>Pickup</label>
                                                <h3>{pickupAddress?.name || pickupAddress?.address_type || "Home"}</h3>
                                                <span>{pickupAddress ? formatAddress(pickupAddress) : "Pickup Address"}</span>
                                            </div>
                                            <Link to="/address?type=pickup" className="edite-icon">
                                                <i className="ti-pencil" />
                                            </Link>
                                        </div>

                                        <div className="to-location d-flex align-items-start" style={{ marginTop: 10 }}>
                                            <div className="icon-ftl">
                                                <i className="ti-arrow-down" />
                                            </div>
                                            <div className="flex-1" style={{ marginLeft: 10 }}>
                                                <label>Drop-Off</label>
                                                <h3>{dropoffAddress?.name || dropoffAddress?.address_type || "Office"}</h3>
                                                <span>{dropoffAddress ? formatAddress(dropoffAddress) : "Drop-Off Address"}</span>
                                            </div>
                                            <Link to="/address?type=dropoff" className="edite-icon">
                                                <i className="ti-pencil" />
                                            </Link>
                                        </div>
                                    </div>

                                    {/* Transported Items */}
                                    {flightDetails?.adminSettings?.showQuotationPrices && (
                                        <div className="vehicle-detail-new mb-3" style={{ marginTop: 10 }}>
                                            <div className="icon-ftl">
                                                <i className="ti-archive" />
                                            </div>
                                            <div className="flex-1 overflow-hidden" style={{ marginLeft: 10 }}>
                                                <label className="mb-1">What Are You Transporting?</label>
                                                <div className="row">
                                                    {items.map((it, idx) => (
                                                        <div className="col-md-6 mb-3" key={idx}>
                                                            <div className="shipment-item-container d-flex">
                                                                <div className="shipment-item-img" style={{ width: 100, height: 100, overflow: "hidden" }}>
                                                                    <img
                                                                        src={it.preview || "/images/defaultImage.jpg"}
                                                                        className="img-fluid"
                                                                        alt={it.itemTitle || "Item"}
                                                                        style={{ height: "100%", width: "100%", objectFit: "cover" }}
                                                                    />
                                                                </div>
                                                                <div className="shipment-item-details" style={{ paddingLeft: 10 }}>
                                                                    <h5>
                                                                        {it.box?.box_type || ""}
                                                                        {/* {it.itemTitle ? `- ${it.itemTitle}` : ""} */}
                                                                    </h5>
                                                                    <p className="small mb-1">{it.description}</p>
                                                                    <p className="small mb-1">
                                                                        Size: {it.itemHeight || 0} cm × {it.itemWidth || 0} cm × {it.itemLength || 0} cm
                                                                    </p>
                                                                    <p className="small mb-1">Box Weight: {it.itemWeight || 0} kg</p>
                                                                    <p className="small mb-1">
                                                                        Quantity:{it.quantity}
                                                                    </p>
                                                                    <p className="small mb-1">
                                                                        Total Weight: {(it?.quantity * it?.itemWeight || 0)} kg
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}

                                                </div>
                                            </div>
                                            <Link to="/Step3" className="edite-icon">
                                                <i className="ti-pencil" />
                                            </Link>
                                        </div>
                                    )}
                                    {/* Pickup Date & Urgency */}
                                    <div className="vehicle-detail-new mb-0" style={{ marginTop: 10 }}>
                                        <div className="icon-ftl">
                                            <i className="ti-calendar" />
                                        </div>
                                        <div className="flex-1" style={{ marginLeft: 10 }}>
                                            <label>Pickup Time</label>
                                            <h3>
                                                {pickupDate
                                                    ? new Date(pickupDate).toLocaleDateString("en-US", {
                                                        weekday: "short",
                                                        month: "short",
                                                        day: "numeric",
                                                    })
                                                    : "Pickup Date not set"}
                                                {pickupTime ? `, ${pickupTime === "Other" ? customTime : pickupTime}` : ""}
                                            </h3>
                                            <h3>
                                                <strong>Estimated Delivery:</strong>{" "}
                                                {selectedFlight ? getEstimatedDelivery(selectedFlight) : "Loading..."}
                                            </h3>
                                            <p>Urgency level: {urgencyLevel || "Not selected"}</p>
                                        </div>
                                        <Link to="/Step4" className="edite-icon">
                                            <i className="ti-pencil" />
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            {/* Right Column */}
                            <div className="col-lg-6">
                                <div className="shipment-details-new">
                                    <h3 className="step-count">STEP 5/5</h3>

                                    {/* Progress bar */}
                                    <div className="progress-container mb-3">
                                        {[...Array(5)].map((_, i) => (
                                            <div key={i} className="new-progress active" />
                                        ))}
                                    </div>

                                    <div className="new-title">
                                        {flightDetails2 && (<h3 className="mb-3">Quotation Details</h3>)}

                                        {loading ? (
                                            <p className="text-center text-muted py-3">Loading quotation details...</p>
                                        ) : !flightDetails ? (
                                            <p className="text-muted">No quotation details available.</p>
                                        ) : flightDetails.adminSettings?.showQuotationPrices ? (
                                            <>
                                                {/* Flight & Charges Section (existing code) */}
                                                {flightDetails2 ? (
                                                    <div className="card mb-3">
                                                        <div className="card-body">
                                                            {/* Flights Section */}
                                                            {flightDetails?.flights?.length > 0 && (
                                                                <>
                                                                    <h5>Flight Details</h5>
                                                                    {flightDetails.flights.map((flight, index) => (
                                                                        <div className="fligh-detail-wrapper mb-4" key={flight.flight_id || index}>
                                                                            <div className="">
                                                                                {/* Flight Info */}
                                                                                <div className="fligh-detail flex-1">
                                                                                    <div className="d-flex gap-3 mb-3 align-items-center">
                                                                                        {flight.airline && (
                                                                                            <img
                                                                                                src={flight.airline_logo || "/images/UnitedAirlines.svg"}
                                                                                                className="img-fluid"
                                                                                                style={{ maxWidth: "50px" }}
                                                                                                alt={flight.airline}
                                                                                            />
                                                                                        )}
                                                                                        <div>
                                                                                            {flight.airline && <h5 className="mb-0">{flight.airline}</h5>}
                                                                                            {flight.flight_number && <p className="mb-0">{flight.flight_number}</p>}
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="flight-from-to d-flex justify-content-between">
                                                                                        <div className="form-lo text-center">
                                                                                            <h5>
                                                                                                {flight.scheduled_departure
                                                                                                    ? new Date(flight.scheduled_departure).toLocaleTimeString([], {
                                                                                                        day: "2-digit",
                                                                                                        month: "2-digit",
                                                                                                        year: "numeric",
                                                                                                        hour: "2-digit",
                                                                                                        minute: "2-digit",
                                                                                                    })
                                                                                                    : "N/A"}
                                                                                            </h5>
                                                                                            <p className="mb-0">{flight.departure_city || "N/A"}</p>
                                                                                        </div>

                                                                                        <div className="total-time text-center">
                                                                                            <h5 className="mb-0">{flight.duration || "N/A"}</h5>
                                                                                            <hr style={{ margin: "5px 0", borderTop: "3px solid" }} />
                                                                                            <p className="mb-0">{flight.status || "Non stop"}</p>
                                                                                        </div>

                                                                                        <div className="to-lo text-center">
                                                                                            <h5>
                                                                                                {flight.scheduled_arrival
                                                                                                    ? new Date(flight.scheduled_arrival).toLocaleTimeString([], {
                                                                                                        day: "2-digit",
                                                                                                        month: "2-digit",
                                                                                                        year: "numeric",
                                                                                                        hour: "2-digit",
                                                                                                        minute: "2-digit",
                                                                                                    })
                                                                                                    : "N/A"}
                                                                                            </h5>
                                                                                            <p className="mb-0">{flight.arrival_city || "N/A"}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                {/* Selection + Cost */}
                                                                                <div>
                                                                                    <div className="fligh-cost" style={{ marginTop: 8 }}>
                                                                                        <h5 className="mb-0">Total Flight Charges</h5>
                                                                                        <h5 className="mb-0">
                                                                                            {flightDetails?.currency_symbol}{flightDetails?.allCharges?.total_carrier_charges || "0"}
                                                                                        </h5>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                    <hr />
                                                                </>
                                                            )}
                                                            {loading2 ?
                                                                <div className="text-center my-4">
                                                                    <div className="spinner-border" role="status"></div>
                                                                    <p className="mt-2">Please wait, we are fetching flight information...</p>
                                                                </div>
                                                                :
                                                                <>
                                                                    <h5>Flight Details</h5>
                                                                    {flightDetails2.map((flightDetails2, index) => (
                                                                        <div className="fligh-detail-wrapper border rounded p-3 mt-2">
                                                                            <div className="fligh-detail flex-1">
                                                                                <div className="d-flex align-items-center gap-3">

                                                                                    {/* LEFT SIDE */}
                                                                                    <div className="d-flex align-items-center gap-3">

                                                                                        <input
                                                                                            className="form-check-input"
                                                                                            type="checkbox"
                                                                                            id={index}
                                                                                            checked={selectedFlight === flightDetails2}
                                                                                            onChange={() => setSelectedFlight(flightDetails2)}
                                                                                        />

                                                                                        <img
                                                                                            src={`https://daisycon.io/images/airline/?width=120&height=80&iata=${flightDetails2?.segments?.[0]?.carrierCode}`}
                                                                                            className="img-fluid"
                                                                                            alt="Airline Logo"
                                                                                            style={{ width: "60px" }}
                                                                                        />

                                                                                        <div>
                                                                                            <h5 className="mb-0">
                                                                                                {flightDetails2?.segments?.[0]?.carrierCode || "N/A"}
                                                                                            </h5>
                                                                                            <p className="mb-0">
                                                                                                {flightDetails2?.segments?.map(s => s.number).join(", ") || "N/A"}
                                                                                            </p>
                                                                                        </div>

                                                                                    </div>

                                                                                    {/* RIGHT SIDE */}
                                                                                    <div className="ms-auto d-flex align-items-center gap-2">

                                                                                        <span className={`badge ${flightDetails2.effective_type === "Cost" ? "bg-success" : "bg-primary"}`}>
                                                                                            {flightDetails2.effective_type + " Effective"}
                                                                                        </span>

                                                                                        <span className="badge bg-success">
                                                                                            $ {flightDetails2?.flight_cost || "0"}
                                                                                        </span>

                                                                                    </div>

                                                                                </div>

                                                                                <div className="flight-from-to">
                                                                                    <div className="form-lo text-center">
                                                                                        <h5>
                                                                                            {flightDetails2?.segments?.[0]?.departure?.at
                                                                                                ? new Date(flightDetails2.segments[0].departure.at).toLocaleTimeString([], {
                                                                                                    day: "2-digit",
                                                                                                    month: "2-digit",
                                                                                                    year: "numeric",
                                                                                                    hour: "2-digit",
                                                                                                    minute: "2-digit",
                                                                                                })
                                                                                                : "N/A"}
                                                                                        </h5>
                                                                                        <p className="mb-0">{flightDetails2?.origin_airport?.iata_code || "N/A"}</p>
                                                                                    </div>

                                                                                    <div className="total-time text-center">
                                                                                        <h5 className="mb-0">{flightDetails2?.flight_duration_hr || "N/A"} hrs</h5>
                                                                                        <hr style={{ margin: "5px 0", borderTop: "3px solid" }} />

                                                                                        {/* Dynamic Stop Count */}
                                                                                        <p className="mb-0">
                                                                                            {flightDetails2?.segments?.length > 1
                                                                                                ? `${flightDetails2.segments.length - 1} Stop(s)`
                                                                                                : "Non stop"}
                                                                                        </p>

                                                                                        {/* Expand/Collapse Button */}
                                                                                        {flightDetails2?.segments?.length > 1 && (
                                                                                            <button
                                                                                                className="btn btn-link p-0 mt-1"
                                                                                                onClick={() => setShowStops(!showStops)}
                                                                                                style={{ fontSize: "14px" }}
                                                                                            >
                                                                                                {showStops ? "Hide Stops" : "View Stops"}
                                                                                            </button>
                                                                                        )}
                                                                                    </div>


                                                                                    <div className="to-lo text-center">
                                                                                        <h5>
                                                                                            {flightDetails2?.segments?.[flightDetails2.segments.length - 1]?.arrival?.at
                                                                                                ? new Date(
                                                                                                    flightDetails2.segments[flightDetails2.segments.length - 1].arrival.at
                                                                                                ).toLocaleTimeString([], {
                                                                                                    day: "2-digit",
                                                                                                    month: "2-digit",
                                                                                                    year: "numeric", hour: "2-digit", minute: "2-digit"
                                                                                                })
                                                                                                : "N/A"}
                                                                                        </h5>
                                                                                        <p className="mb-0">{flightDetails2?.dest_airport?.iata_code || "N/A"}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            {/* Expanded Stops List */}
                                                                            {showStops && (
                                                                                <div className="my-2 p-2 bg-light">
                                                                                    {flightDetails2.segments.map((seg, index) => (
                                                                                        <div key={index} className="d-flex justify-content-between mb-2">
                                                                                            <div>
                                                                                                <strong>From:</strong> {seg.departure.iataCode}
                                                                                                <br />
                                                                                                <span>
                                                                                                    {new Date(seg.departure.at).toLocaleTimeString([], {
                                                                                                        day: "2-digit",
                                                                                                        month: "2-digit",
                                                                                                        year: "numeric",
                                                                                                        hour: "2-digit",
                                                                                                        minute: "2-digit",
                                                                                                    })}
                                                                                                </span>
                                                                                            </div>
                                                                                            {/* Dotted Line with Airplane */}
                                                                                            <div className="flight-middle flex-grow-1 px-2 bg-light align-self-center">
                                                                                                <div className="flight-line"></div>
                                                                                                <span className="flight-icon bg-light">✈</span>
                                                                                            </div>
                                                                                            <div>
                                                                                                <strong>To:</strong> {seg.arrival.iataCode}
                                                                                                <br />
                                                                                                <span>
                                                                                                    {new Date(seg.arrival.at).toLocaleTimeString([], {
                                                                                                        day: "2-digit",
                                                                                                        month: "2-digit",
                                                                                                        year: "numeric",
                                                                                                        hour: "2-digit",
                                                                                                        minute: "2-digit",
                                                                                                    })}
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            )}
                                                                            {/*  <div className="fligh-cost">
                                                                                <h5 className="mb-0">Total Flight Charges</h5>
                                                                                <h5 className="mb-0">
                                                                                    $ {flightDetails2?.flight_cost || "0"}
                                                                                </h5>
                                                                            </div> */}
                                                                        </div>
                                                                    ))}
                                                                    <hr />
                                                                    <h5>Carrier Charges</h5>
                                                                    {/* Carrier / Handling Charges */}
                                                                    <div className="fligh-detail-wrapper">
                                                                        <div className="fligh-detail flex-1">
                                                                            {/* <div className="d-flex gap-3 mb-1 justify-content-between">
                                        <p className="mb-0">Carrier Fees</p>
                                        <p className="mb-0">{flightDetails?.currency_symbol} {Number(flightDetails2?.flight_cost || 0).toFixed(2)}</p>
                                      </div> */}
                                                                            <div className="d-flex gap-3 mb-1 justify-content-between">
                                                                                <p className="mb-0">Pick Up Charges</p>
                                                                                <p className="mb-0">{flightDetails?.currency_symbol} {Number(selectedFlight?.roadCostFrom || 0).toFixed(2)}</p>
                                                                            </div>
                                                                            <div className="d-flex gap-3 mb-1 justify-content-between">
                                                                                <p className="mb-0">Drop-off Charges</p>
                                                                                <p className="mb-0">{flightDetails?.currency_symbol} {Number(selectedFlight?.roadCostTo || 0).toFixed(2)}</p>
                                                                            </div>
                                                                            <div className="d-flex gap-3 mb-1 justify-content-between">
                                                                                <p className="mb-0">Flight Charges</p>
                                                                                <p className="mb-0">{flightDetails?.currency_symbol} {Number(selectedFlight?.flight_cost || 0).toFixed(2)}</p>
                                                                            </div>
                                                                        </div>

                                                                        <div className="fligh-cost">
                                                                            <h5 className="mb-0">Total Carrier Charges</h5>
                                                                            <h5 className="mb-0">
                                                                                {flightDetails?.currency_symbol} {(
                                                                                    Number(selectedFlight?.flight_cost || 0) +
                                                                                    Number(selectedFlight?.roadCostFrom || 0) +
                                                                                    Number(selectedFlight?.roadCostTo || 0)
                                                                                ).toFixed(2)}
                                                                            </h5>
                                                                        </div>
                                                                    </div>

                                                                    <hr />
                                                                    <h5>Handling Charges</h5>
                                                                    <div className="fligh-detail-wrapper">
                                                                        <div className="fligh-detail flex-1">
                                                                            {

                                                                                flightDetails.allCharges?.other_charges?.custom_clearance_charges && (
                                                                                    <div className="d-flex gap-3 mb-1 justify-content-between">
                                                                                        <p className="mb-0">Custom Clearance Charges</p>
                                                                                        <p className="mb-0">
                                                                                            {flightDetails?.currency_symbol}
                                                                                            {(
                                                                                                parseFloat(flightDetails.allCharges?.other_charges?.custom_clearance_charges || 0) *
                                                                                                (Number(CCImport) + Number(CCExport))
                                                                                            ).toFixed(2)}
                                                                                        </p>
                                                                                    </div>
                                                                                )

                                                                            }
                                                                            {flightDetails.allCharges?.other_charges?.documentation_charges && (
                                                                                <div className="d-flex gap-3 mb-1 justify-content-between">
                                                                                    <p className="mb-0">Documentation Charges</p>
                                                                                    <p className="mb-0">{flightDetails?.currency_symbol}{parseFloat(flightDetails.allCharges?.other_charges.documentation_charges).toFixed(2)}</p>
                                                                                </div>
                                                                            )}
                                                                            {flightDetails.allCharges?.other_charges?.other_miscellaneous_charges && (
                                                                                <div className="d-flex gap-3 mb-1 justify-content-between">
                                                                                    <p className="mb-0">Other Charges</p>
                                                                                    <p className="mb-0">{flightDetails?.currency_symbol}{parseFloat(flightDetails.allCharges.other_charges?.other_miscellaneous_charges).toFixed(2)}</p>
                                                                                </div>
                                                                            )}

                                                                        </div>
                                                                        <div className="fligh-cost">
                                                                            <h5 className="mb-0">Total Handling Charges</h5>
                                                                            <h5 className="mb-0">{flightDetails?.currency_symbol}
                                                                                {(
                                                                                    (
                                                                                        Number(flightDetails.allCharges?.other_charges?.custom_clearance_charges || 0) *
                                                                                        (Number(CCImport) + Number(CCExport))
                                                                                    ) +
                                                                                    Number(flightDetails.allCharges?.other_charges?.documentation_charges || 0) +
                                                                                    Number(flightDetails.allCharges?.other_charges?.other_miscellaneous_charges || 0)
                                                                                ).toFixed(2)}
                                                                            </h5>
                                                                        </div>
                                                                    </div>
                                                                    <hr />
                                                                    <div className="fligh-cost">
                                                                        <h5 className="mb-0">Service Charges</h5>
                                                                        <h5 className="mb-0">{flightDetails?.currency_symbol} {(
                                                                            Number(selectedFlight?.percentage_charges_total || 0)
                                                                        ).toFixed(2)}</h5>
                                                                    </div>

                                                                    <hr />
                                                                    <div className="fligh-cost">
                                                                        <h5 className="mb-0">Total Pay Amount</h5>
                                                                        <h3 className="mb-0">
                                                                            {flightDetails?.currency_symbol}
                                                                            {(
                                                                                Number(selectedFlight?.flight_cost || 0) +
                                                                                Number(selectedFlight?.roadCostFrom || 0) +
                                                                                Number(selectedFlight?.roadCostTo || 0) +
                                                                                Number(selectedFlight?.percentage_charges_total || 0) +

                                                                                // ✅ Added your extra charges here
                                                                                (
                                                                                    Number(flightDetails.allCharges?.other_charges?.custom_clearance_charges || 0) *
                                                                                    (Number(CCImport) + Number(CCExport))
                                                                                ) +
                                                                                Number(flightDetails.allCharges?.other_charges?.documentation_charges || 0) +
                                                                                Number(flightDetails.allCharges?.other_charges?.other_miscellaneous_charges || 0)

                                                                            ).toFixed(2)}
                                                                        </h3>
                                                                    </div>
                                                                </>
                                                            }
                                                        </div>
                                                    </div>
                                                ) :
                                                    <>
                                                        {loading2 ?
                                                            <div className="text-center my-4">
                                                                <div className="spinner-border" role="status"></div>
                                                                <p className="mt-2">Please wait, we are fetching flight information...</p>
                                                            </div>
                                                            :
                                                            <div className="card text-center align-content-center">
                                                                <h5 className="mt-3">No direct flights are available for this route.</h5>
                                                                <p>You can still proceed by submitting a quotation request.</p>
                                                            </div>
                                                        }
                                                    </>
                                                }
                                            </>
                                        ) : (
                                            <>
                                                {/* Only show "What Are You Transporting?" if showQuotationPrices is false */}
                                                <div className="card mb-3">
                                                    <div className="card-body">
                                                        <div className="vehicle-detail-new mb-3" style={{ marginTop: 10 }}>
                                                            <div className="icon-ftl">
                                                                <i className="ti-archive" />
                                                            </div>
                                                            <div className="flex-1 overflow-hidden" style={{ marginLeft: 10 }}>
                                                                <label className="mb-1">What Are You Transporting?</label>
                                                                <div className="row">
                                                                    {items.map((it, idx) => (
                                                                        <div className="col-md-6 mb-3" key={idx}>
                                                                            <div className="shipment-item-container d-flex">
                                                                                <div className="shipment-item-img">
                                                                                    <img
                                                                                        src={it.preview || "/images/defaultImage.jpg"}
                                                                                        className="img-fluid"
                                                                                        alt={it.itemTitle || "Item"}
                                                                                        style={{ height: "100%", width: "100%", objectFit: "cover" }}
                                                                                    />
                                                                                </div>
                                                                                <div className="shipment-item-details" style={{ paddingLeft: 10 }}>
                                                                                    <h5>
                                                                                        {it.box?.box_type || ""}
                                                                                        {/* {it.itemTitle ? `- ${it.itemTitle}` : ""} */}
                                                                                    </h5>
                                                                                    <p className="small mb-1">{it.description}</p>
                                                                                    <p className="small mb-1">
                                                                                        Size: {it.itemHeight || 0} cm × {it.itemWidth || 0} cm × {it.itemLength || 0} cm
                                                                                    </p>
                                                                                    <p className="small mb-1">Box Weight: {it.itemWeight || 0} kg</p>
                                                                                    <p className="small mb-1">
                                                                                        Quantity:{it.quantity}
                                                                                    </p>
                                                                                    <p className="small mb-1">
                                                                                        Total Weight: {(it?.quantity * it?.itemWeight || 0)} kg
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}

                                                                </div>
                                                            </div>
                                                            <Link to="/Step3" className="edite-icon">
                                                                <i className="ti-pencil" />
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>

                                    <div className="card mb-3">
                                        <div className="card-body">
                                            <div className="form-group" style={{ backgroundColor: "#fff" }}>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="flexCheckChecked"
                                                        checked={termsChecked}
                                                        onChange={() => setTermsChecked(!termsChecked)}
                                                    />
                                                    <label
                                                        className="form-check-label terms-conditions"
                                                        htmlFor="flexCheckChecked"
                                                        style={{ fontSize: '14px', lineHeight: 1.5 }}
                                                    >
                                                        The estimated timelines and prices shown have been calculated by our beta model using highly conservative parameters. In many cases, we can even improve the timeline and price after you submit your non-binding transport request. By clicking the button below, you enter no payment or order obligation – you're simply requesting us to prepare a firm, non-binding quote
                                                    </label>
                                                </div>
                                                <div className="form-check d-flex align-items-center">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="flexCheckChecked3"
                                                        checked={testRequest}
                                                        onChange={() => setTestRequest(!testRequest)}
                                                    />
                                                    <label
                                                        className="form-check-label terms-conditions"
                                                        htmlFor="flexCheckChecked3"
                                                        style={{ fontSize: '14px', lineHeight: 1.5 }}
                                                    >
                                                        This is a test request
                                                    </label>
                                                </div>
                                                <div className="form-check d-flex align-items-center">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="flexCheckChecked2"
                                                        checked={CCImport}
                                                        onChange={() => setCCImport(!CCImport)}
                                                    />
                                                    <label
                                                        className="form-check-label terms-conditions"
                                                        htmlFor="flexCheckChecked2"
                                                        style={{ fontSize: '14px', lineHeight: 1.5 }}
                                                    >
                                                        I require import customs clearance to be included
                                                    </label>
                                                </div>
                                                <div className="form-check d-flex align-items-center">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="flexCheckChecked1"
                                                        checked={CCExport}
                                                        onChange={() => setCCExport(!CCExport)}
                                                    />
                                                    <label
                                                        className="form-check-label terms-conditions"
                                                        htmlFor="flexCheckChecked1"
                                                        style={{ fontSize: '14px', lineHeight: 1.5 }}
                                                    >
                                                        I require export customs clearance to be included
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {!termsChecked && showError ? <span className="text-danger mt-2">Please confirm that you’ve read and understood our quote terms.</span> : null}
                                    {/* Bottom Button */}
                                    <div className="button-wraper-new mt-3">
                                        <button className="btn btn-success btn-lg w-100" onClick={() => {
                                            setShowError(true)
                                            if (termsChecked) {
                                                handleQuote()
                                            }
                                        }} disabled={submitting || loading2}>
                                            {submitting ? "Processing..." : "Request Quotes"}
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>

                {/* Success Modal */}
                <div className="modal fade" id="sucessModalToggle" aria-hidden="true" tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="text-center">
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    <img src="/images/sucess.jpg" className="img-fluid sucess-img" alt="success" />
                                    <h5 className="modal-title">Request Submitted!</h5>
                                    <p>
                                        Your booking request has been submitted and is pending admin approval. Once approved, you will be notified to proceed with payment and confirm your shipment.
                                    </p>
                                    <button className="btn btn-success" onClick={handleDashboardClick}>
                                        Dashboard
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> {/* page-content */}
        </div>
    );
};

export default Step5;
